export default __webpack_public_path__ + "static/footer-700cea9135851d9f1212446deca6dc8a.svg";